import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as scenarioGridSelectors from '@makemydeal/dr-dash-store/selectors/scenarioGridSelectors';

import { OUTSIDE_LIENHOLDER_HEADER_NAME } from '../../../../baseDealActivity/OutsideLienholder/constants';
import { RowNote } from '../../../ScenarioGrid.style';
import { OUTSIDE_LIENHOLDER_SUB_ROW_KEYS, useOutsideLienholderExpansion } from './OutsideLienholderExpansion';
import { ScenarioRow } from '../../ScenarioRow';
import { ScenarioSubRow } from '../../ScenarioSubRow';

export const FLEX_BUY_DEAL_TYPE_LABEL = 'Flex Buy';

export const OutsideLienholderNotApplicableRow = () => {
    const theme = useInterstateTheme();
    const { isExpanded } = useOutsideLienholderExpansion();
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isFlexBuyDeal = useSelector(scenarioGridSelectors.isFlexBuyDeal);
    const dealTypeLabel = isFlexBuyDeal ? FLEX_BUY_DEAL_TYPE_LABEL : offerType.charAt(0).toUpperCase() + offerType.slice(1);

    return (
        <>
            <ScenarioRow rowKey="outsideLienholder">
                <RowNote theme={theme} data-testid="scenario-row-outsideLienholder-not-applicable">
                    {`${OUTSIDE_LIENHOLDER_HEADER_NAME} not applicable for ${dealTypeLabel}`}
                </RowNote>
            </ScenarioRow>
            {isExpanded &&
                OUTSIDE_LIENHOLDER_SUB_ROW_KEYS.map((subRowKey) => <ScenarioSubRow key={subRowKey} subRowKey={subRowKey} />)}
        </>
    );
};
